import ProtectedRoute from '../authentication/components/ProtectedRoute';
import DashboardPage from '../dashboard/pages/DashboardPage';
import { Navigate, Route, Routes } from 'react-router-dom';
import React from 'react';
import OrganizationEditPage from '../organizations/pages/OrganizationEditPage';
import OrganizationsPage from '../organizations/pages/OrganizationPage';

export const EmbeddedPartnerRoutes = () => (
  <>
    <Route
      path="/dashboard"
      element={
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/organizations"
      element={
        <ProtectedRoute>
          <OrganizationsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/organizations/edit/:id"
      element={
        <ProtectedRoute>
          <OrganizationEditPage />
        </ProtectedRoute>
      }
    />
  </>
);
